import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/travel',
    name: 'travel-view',
    component: () => import('../views/Travel.vue')
  },
  {
    path: '/home-decor',
    name: 'home-decor',
    component: () => import('../views/HomeDecor.vue')
  },
  {
    path: '/living',
    name: 'living',
    component: () => import('../views/LivingView.vue')
  },
  {
    path: '/beaches',
    name: 'beaches',
    component: () => import('../views/BeachesView.vue')
  },
  {
    path: '/interior',
    name: 'interior',
    component: () => import('../views/InteriorView.vue')
  },
  {
    path: '/furniture',
    name: 'furniture',
    component: () => import('../views/FurnitureView.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/SearchView.vue')
  },
  {
    path: '/blog-details',
    name: 'blog-details',
    component: () => import('../views/BlogDetails.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return window.scrollTo({ 
        top: document.querySelector(to.hash).offsetTop, 
        behavior: 'smooth' 
      })
    } else {
      return {
        left: 0,
        top: 0
      }
    }
  }
})

export default router
